import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authRedirectService } from '../services/authRedirectService';
import { useMeetingLink } from './useMeetingLink';
import { useUser } from './useUserData';

function usePostAuthRedirect(): void {
  const navigate = useNavigate();
  const { meetingId } = useMeetingLink();
  const { isAuthenticated, idToken } = useUser();

  useEffect(() => {
    if (!(isAuthenticated && idToken)) {
      return;
    }

    const redirectUrl = authRedirectService.consumeRedirect(meetingId);
    if (redirectUrl) {
      navigate(redirectUrl);
    }
  }, [isAuthenticated, idToken, meetingId, navigate]);
}

export default usePostAuthRedirect;
